import Vue from 'vue'
import Router from 'vue-router'
import TeamRouter from '@/router/team'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'Login',
            component: r => require.ensure([], () => r(require('@/views/login/login')), 'login')
        },
        {
            path: '/goodTopic/list',
            name: 'list',
            meta: {keepAlive: true},
            component: r => require.ensure([], () => r(require('@/views/goodTopic/list')), 'list')
        },
        {
            path: '/goodTopic/detail',
            name: 'detail',
            component: r => require.ensure([], () => r(require('@/views/goodTopic/detail')), 'detail')
        },
        {
            path: '/correctionResults',
            name: 'correctionResults',
            component: r => require.ensure([], () => r(require('@/views/correctionResults/correctionResults')), 'correctionResults')
        },
        // {
        //     path: '/faq/quickStart',
        //     name: 'quickStart',
        //     component: r => require.ensure([], () => r(require('@/views/faq/quickStart')), 'quickStart')
        // },
        // {
        //     path: '/faq/subjob',
        //     name: 'subjob',
        //     component: r => require.ensure([], () => r(require('@/views/faq/subjob')), 'subjob')
        // },
        {
            path: '/:code/team',
            name: 'Team',
            component: r => require.ensure([], () => r(require('@/views/team/index')), 'team'),
            children: TeamRouter
        }
        // {
        //     path: '/:code/team/chapter',
        //     name: 'Chapter',
        //     component: r => require.ensure([], () => r(require('@/views/team/chapter')), 'chapter'),
        //     meta: {
        //         title: '查漏补缺'
        //     }
        // },
        // {
        //     path: '/:code/team/details/:sectionCode',
        //     name: 'Details',
        //     component: r => require.ensure([], () => r(require('@/views/team/details')), 'details'),
        //     meta: {
        //         title: '查漏补缺'
        //     }
        // },
        // {
        //     path: '/:code/team/exam',
        //     name: 'Exam',
        //     component: r => require.ensure([], () => r(require('@/views/team/exam')), 'exam'),
        //     meta: {
        //         title: '超越自我'
        //     }
        // }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js